
<div class="intent-selection">
  <main-nav />
  <cvt-left-side-bar class="marketplace-left-nav-bar intent-sidebar">
    <cvt-button
      :loading="false"
      class="back-btn"
      text=""
      icon="arrow-left"
      @click="goBack"
    />
    <h2 class="template-ready-title mt-4">
      {{ $t('gen_ai.template.title') }}
    </h2>
    <p class="template-review mt-3">
      {{ $t('gen_ai.template.description_1') }}
      <b>{{ $t('gen_ai.template.description_2') }}</b>
      {{ $t('gen_ai.template.description_3') }}
      <b>{{ $t('gen_ai.template.description_4') }}</b>
      {{ $t('gen_ai.template.description_5') }}
    </p>
    <cvt-button
      :loading="false"
      class="mt-3 magic-btn"
      :text="$t('gen_ai.template.continue_btn')"
      icon="wand-magic"
      :prepend="true"
      @click="switchTemplate"
    />
  </cvt-left-side-bar>
  <div class="content-wrapper">
    <div class="content">
      <h2>{{ templates[activeTemplate] }}</h2>
    </div>
  </div>
</div>
